import { useEffect } from 'react';
import { useSettingsStore } from '@/features/settings/stores/settings-store';

export function ThemeManager() {
    const theme = useSettingsStore((s) => s.theme);

    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(theme);
    }, [theme]);

    return null;
}
